import User from './User'
import UserDependencies from './UserDependencies'

export default new User(UserDependencies)
